import { i18n, type MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import type { SmsLogCategory, SmsLogStatus } from '@saas/api-client';

type SmsStatusConfig = {
	label: MessageDescriptor;
	variant: 'default' | 'secondary' | 'destructive' | 'outline';
};

export const SMS_STATUSES = ['SENT', 'DELIVERED', 'UNDELIVERED', 'FAILED'] as const satisfies readonly SmsLogStatus[];

export const SMS_CATEGORIES = [
	'MEETING_INVITE',
	'MEETING_RESCHEDULE',
	'MEETING_CANCEL',
	'MEETING_REMINDER',
	'MEETING_SUMMARY',
	'BOOKING_REMINDER',
	'BOOKING_HOST_NOTIFICATION',
	'OFFER',
	'OFFER_REMINDER',
	'RECORD_AND_SEND_INVITE',
] as const satisfies readonly SmsLogCategory[];

export const SMS_STATUS_CONFIG = {
	SENT: { label: msg`Sent`, variant: 'secondary' },
	DELIVERED: { label: msg`Delivered`, variant: 'default' },
	UNDELIVERED: { label: msg`Undelivered`, variant: 'destructive' },
	FAILED: { label: msg`Failed`, variant: 'destructive' },
} satisfies Record<SmsLogStatus, SmsStatusConfig>;

const SMS_CATEGORY_LABELS = {
	MEETING_INVITE: msg`Meeting invite`,
	MEETING_RESCHEDULE: msg`Meeting rescheduled`,
	MEETING_CANCEL: msg`Meeting cancelled`,
	MEETING_REMINDER: msg`Meeting reminder`,
	MEETING_SUMMARY: msg`Meeting summary`,
	BOOKING_REMINDER: msg`Booking reminder`,
	BOOKING_HOST_NOTIFICATION: msg`New booking notice`,
	OFFER: msg`Offer`,
	OFFER_REMINDER: msg`Offer reminder`,
	RECORD_AND_SEND_INVITE: msg`Video request`,
} satisfies Record<SmsLogCategory, MessageDescriptor>;

export const smsStatusLabel = (status: SmsLogStatus): string => i18n._(SMS_STATUS_CONFIG[status].label);

export const smsCategoryLabel = (category: SmsLogCategory): string => i18n._(SMS_CATEGORY_LABELS[category]);
